import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Switch, Route, useLocation } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import Home from './Home';
import SignIn from './SignIn';
import Register from './Register';
import Forgot from './Forgot';
import Verify from './Verify';

ReactDOM.render((
    <HashRouter>
        <Switch>
            <Route exact path="/" render={() => {
                return <Home/>
            }}/>
            <Route path="/register" render={() => {
                return <Register/>
            }}/>
            <Route path="/verify/:user/:hash" component={(props) => {
                console.log("porps: " + JSON.stringify(props))
                return <Verify {...props}/>
            }}/>
            <Route exact path="/forgot" render={() => {
                return <Forgot/>
            }}/>
            <Route path="/signin" component={() => {
                let query = new URLSearchParams(useLocation().search);
                if(query.get("redirect") !== null) {
                    return <SignIn oauth={query.get("oauth")} redirect={query.get("redirect")}/>
                } else {
                    return <SignIn />
                }
            }}/>
        </Switch>
    </HashRouter>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
